import { NgModule } from '@angular/core';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { ViewsRoutingModule } from './views-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TokenInterceptor } from '@core/interceptors/token-interceptor';
import { StorybookModule } from '@app/storybook.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

const useValue = environment.production
  ? '/cl/ventaenverde'
  : window['_app_base'] || '/';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    ViewsRoutingModule,
    StorybookModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: APP_BASE_HREF, useValue },
  ],
})
export class ViewsModule {}
